import { SignalItem } from "../../interface/SignalItem"
import FormControlLabel from '@mui/material/FormControlLabel';

import Switch from '@mui/material/Switch';
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../interface/ApplicationState";
import { updateLocalUser } from "../../redux/actions/userActions";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import { alpha, useTheme } from "@mui/material/styles";


interface SignalSourceProps
{
  signal: SignalItem
}

export const SignalSource = ({ signal }: SignalSourceProps) =>
{
  const dispatch = useDispatch();
  const theme = useTheme()
  const signalsInvestSources = useSelector((state: ApplicationState) => state.userStore.user.signalsInvestSources) || [];

  const isEnabled = () =>
  {
    if(signalsInvestSources && signalsInvestSources.includes(signal.source)) return true;
  }

  const handleChange = (e: any) =>
  {
    if(e.target.checked)
    {
      dispatch(updateLocalUser({ signalsInvestSources: [ signal.source, ...signalsInvestSources ] }))
    }
    else
    {
      dispatch(updateLocalUser({ signalsInvestSources: signalsInvestSources.filter(s => s !== signal.source) }))
    }
  }

  return(
    <Box sx={styles.item(theme, !!isEnabled())}>
      <Stack direction="row" spacing={1.25} alignItems="center" justifyContent="space-between">
        <Box>
          <Typography variant="subtitle1" fontWeight={700}>
            {signal.source}
          </Typography>
          <Stack direction="row" spacing={0.75} useFlexGap flexWrap="wrap" sx={{ mt: 0.6 }}>
            <Chip size="small" label={signal.direction} sx={styles.chip(theme)} />
            <Chip size="small" label={`${signal.pair}`} sx={styles.chip(theme)} />
            <Chip size="small" label={`${signal.timeout}m timeout`} sx={styles.chip(theme)} />
          </Stack>
        </Box>
        <FormControlLabel
          sx={{ mr: 0 }}
          control={<Switch checked={!!isEnabled()} onChange={handleChange} name={signal.source} />}
          label={isEnabled() ? "Enabled" : "Disabled"} />
      </Stack>
    </Box>

  )
}

const styles = {
  item: (theme: any, enabled: boolean) => ({
    padding: 1,
    margin: 0.25,
    borderRadius: "10px",
    border: `1px solid ${enabled ? alpha(theme.palette.info.main, 0.45) : alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.06 : 0.35)}`,
    backgroundColor: enabled
      ? alpha(theme.palette.info.main, theme.palette.mode === "dark" ? 0.12 : 0.08)
      : alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.02 : 0.56),
    '& + &': {
    },
  }),
  chip: (theme: any) => ({
    borderRadius: "8px",
    backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.08 : 0.72),
    '& .MuiChip-label': {
      fontWeight: 600,
    },
  }),
}
